import CuoButton from "@/app/admin/_common/CuoButton";
import { FestivalForm } from "../../_cmp/festivalForm/FestivalForm";
import { useFestivalFormFlow } from "../../_cmp/festivalForm/useFestivalFormFlow";
import type { Festival } from "@/app/_services/FestivalService";

export default function FestivalDetailsTab({
  festival,
  onSaved,
}: {
  festival: Festival;
  onSaved: () => void;
}) {
  const { control, errors, isSaving, isDirty, setSelectedImage, handleSave, discardChanges } =
    useFestivalFormFlow({ defaultFestival: festival, onSaved });

  return (
    <div className="mx-auto flex w-full max-w-[920px] flex-col gap-3 pb-16">
      <FestivalForm
        control={control}
        errors={errors}
        defaultFestival={festival}
        onImageSelect={setSelectedImage}
        layout="split"
      />

      {isDirty && (
        <div className="sticky bottom-5 z-10 mx-auto flex w-full max-w-[920px] items-center justify-between gap-3 rounded-md border border-border bg-card px-5 py-3">
          <span className="text-[12.5px] text-muted-foreground">You have unsaved changes</span>
          <div className="flex items-center gap-2">
            <CuoButton variant="outline" label="Discard" onClick={discardChanges} disabled={isSaving} />
            <CuoButton variant="default" label="Save" onClick={handleSave} disableOnAsync={isSaving} />
          </div>
        </div>
      )}
    </div>
  );
}
